import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BranchOffice } from '@api/BranchOffices/BranchOffice';
import { DistributionCenter } from '@api/DistributionCenters/DistributionCenter';
import { SalesChannel } from '@api/SalesChannels/SalesChannel';
import { PromotionalCode } from '@api/PromotionalCodes/PromotionalCode';
import { CashRegister } from '@api/CashRegister/CashRegister';

export interface KrispisState {
    lastUpdate: number;
    branchOffices: BranchOffice[];
    distributionCenters: DistributionCenter[];
    salesChannels: SalesChannel[];
    promotionalCodes: PromotionalCode[];
    cashRegister?: CashRegister;
}

const initialState: KrispisState = {
    lastUpdate: Date.now(),
    branchOffices: [],
    distributionCenters: [],
    salesChannels: [],
    promotionalCodes: []
};

const krispisSlice = createSlice({
    name: 'krispis',
    initialState,
    reducers: {
        setBranchOffices: (state, action: PayloadAction<BranchOffice[]>) => {
            state.branchOffices = action.payload;
            state.lastUpdate = Date.now();
        },
        setDistributionCenters: (state, action: PayloadAction<DistributionCenter[]>) => {
            state.distributionCenters = action.payload;
            state.lastUpdate = Date.now();
        },
        setSalesChannels: (state, action: PayloadAction<SalesChannel[]>) => {
            state.salesChannels = action.payload;
            state.lastUpdate = Date.now();
        },
        setPromotionalCodes: (state, action: PayloadAction<PromotionalCode[]>) => {
            state.promotionalCodes = action.payload;
            state.lastUpdate = Date.now();
        },
        setCashRegister: (state, action: PayloadAction<CashRegister | undefined>) => {
            state.cashRegister = action.payload;
            state.lastUpdate = Date.now();
        }
    }
});

export const { setBranchOffices, setDistributionCenters, setSalesChannels, setPromotionalCodes, setCashRegister } =
    krispisSlice.actions;

export default krispisSlice.reducer;
